<template>
  <div>
    <div class="form">
      <el-form ref="form" :model="form" label-width="111px" :rules="rules">
        <!-- 基本信息 -->
        <el-form-item>
          <div class="H">
            <div class="line"></div>
            <div class="title">基本信息</div>
          </div>
        </el-form-item>

        <div class="table">
          <div class="img_name_sex">
            <el-form-item label="人物图片：" class="formItemDuty" style="border-top: 0px">
              <div class="left_right one headPortrait">
                <uploadLogo
                  :imageShow="form.headPortrait"
                  @uploadOneImgShow="uploadOneImgShow"
                ></uploadLogo>
              </div>
            </el-form-item>

            <el-form-item
              prop="name"
              label="人物姓名："
              class="formItemDuty"
              style="border-top: 0px"
            >
              <div class="left_right two">
                <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
              </div>
            </el-form-item>

            <el-form-item label="性别：" prop="sex" class="formItemDuty" style="border-top: 0px">
              <div class="left_right three sex">
                <el-radio-group v-model="form.sex">
                  <el-radio label="男">男</el-radio>
                  <el-radio label="女">女</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
          </div>

          <div class="age_native_phone">
            <el-form-item label="年龄：" prop="age" class="formItemDuty" style="border-top: 0px">
              <div class="left_right one">
                <el-input v-model="form.age" placeholder="请输入年龄"></el-input>
              </div>
            </el-form-item>

            <el-form-item
              label="籍贯："
              prop="nativePlace"
              class="formItemDuty"
              style="border-top: 0px"
            >
              <div class="left_right two">
                <el-input v-model="form.nativePlace" placeholder="请输入籍贯"></el-input>
              </div>
            </el-form-item>

            <el-form-item
              label="手机号："
              prop="phone"
              class="formItemDuty"
              style="border-top: 0px"
            >
              <div class="left_right three">
                <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
              </div>
            </el-form-item>
          </div>

          <div class="email_WeChat_position">
            <el-form-item label="邮箱：" prop="email" class="formItemDuty" style="border-top: 0px">
              <div class="left_right one">
                <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
              </div>
            </el-form-item>

            <el-form-item label="微信：" class="formItemDuty" style="border-top: 0px">
              <div class="left_right two">
                <el-input v-model="form.weChat" placeholder="请输入微信号"></el-input>
              </div>
            </el-form-item>

            <el-form-item label="地点：" class="formItemDuty" style="border-top: 0px">
              <div class="left_right three">
                <CascaderArea
                  :country="form.nation"
                  :province="form.province"
                  :city="form.city"
                  @searchArae="searchArae"
                ></CascaderArea>
              </div>
            </el-form-item>
          </div>

          <div class="enterprise_work_description">
            <el-form-item
              label="当前企业："
              prop="enterprise"
              class="formItemDuty"
              style="border-top: 0px"
            >
              <div class="left_right one">
                <el-input v-model="form.enterprise" placeholder="请输入当前企业"></el-input>
              </div>
            </el-form-item>

            <el-form-item
              label="当前职位："
              prop="position"
              class="formItemDuty"
              style="border-top: 0px"
            >
              <div class="left_right two">
                <el-input v-model="form.position" placeholder="请输入当前职位"></el-input>
              </div>
            </el-form-item>

            <el-form-item
              label="人物简介"
              prop="briefIntroduction"
              class="formItemDuty"
              style="border-top: 0px"
            >
              <div class="left_right three">
                <el-input v-model="form.briefIntroduction" placeholder="请输入人物简介"></el-input>
              </div>
            </el-form-item>
          </div>
        </div>

        <el-form-item>
          <div class="H" style="margin-top: 20px; margin-bottom: 0px">
            <div class="line"></div>
            <div class="title">教育经历</div>
            <div class="addition" @click="clickAddDducation">
              <i class="el-icon-circle-plus-outline"></i>
              <div class="addText">添加</div>
            </div>
          </div>
        </el-form-item>

        <div>
          <el-form-item label="教育经历：">
            <div class="educationItem" v-for="(item, index) in thoroughList" :key="index">
              <div class="date_school">
                <el-date-picker
                  v-model="thoroughList[index].startDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="开始年月"
                >
                </el-date-picker>
                <span style="display: inline-block; margin: 0 11px; color: #999999">~</span>
                <el-date-picker
                  v-model="thoroughList[index].endDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="结束年月"
                >
                </el-date-picker>
                <el-input
                  placeholder="请输入学校名称"
                  v-model="thoroughList[index].schoolName"
                  clearable
                  class="schoolName"
                >
                </el-input>
              </div>
              <div class="education_background">
                <el-input
                  class="input1"
                  placeholder="请输入院系"
                  v-model="thoroughList[index].department"
                  clearable
                >
                </el-input>

                <el-input
                  class="input2"
                  placeholder="请输入专业名称"
                  v-model="thoroughList[index].major"
                  clearable
                >
                </el-input>

                <el-select v-model="thoroughList[index].education" placeholder="请选择学历">
                  <el-option v-for="item in educationList" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="operating_button">
                <div class="save" @click="clickEducationSave(index)">保存</div>
                <div class="cancel" @click="clickCancelEducation(index)">取消</div>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="thorough1">
          <div
            class="thorough1_item"
            @mouseover="item.isShow = true"
            @mouseleave="item.isShow = false"
            v-for="(item, index) in form.educationals"
            :key="index"
          >
            <div class="thorough1_icon"></div>
            <div class="thorough1_time">{{ item.startDate }}~{{ item.endDate }}</div>
            <div class="thorough1_Msg">
              {{ item.schoolName }} · {{ item.department }} · {{ item.major }} ·
              {{ item.education }}
            </div>
            <div class="thorough1_operate" v-show="item.isShow">
              <div class="compile" @click="thoroughCompile(item, index)">
                <i class="el-icon-edit"></i>
              </div>
              <div class="removeTh" @click="thoroughRemove(index)">
                <i class="el-icon-delete"></i>
              </div>
            </div>
          </div>
        </div>

        <el-form-item>
          <div class="H" style="margin-top: 20px; margin-bottom: 0px">
            <div class="line"></div>
            <div class="title">工作经历</div>
            <div class="addition" @click="clickAddExperiences">
              <i class="el-icon-circle-plus-outline"></i>
              <div class="addText">添加</div>
            </div>
          </div>
        </el-form-item>

        <div>
          <el-form-item label="工作经历：">
            <div class="experiencesItem" v-for="(item, index) in thoroughList1" :key="index">
              <div class="date_school">
                <el-date-picker
                  v-model="thoroughList1[index].inductionTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="开始年月"
                >
                </el-date-picker>
                <span style="display: inline-block; margin: 0 11px; color: #999999">~</span>
                <el-date-picker
                  v-model="thoroughList1[index].quitTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="结束年月"
                >
                </el-date-picker>

                <el-input
                  placeholder="请输入企业名称"
                  v-model="thoroughList1[index].companyName"
                  clearable
                  class="schoolName"
                >
                </el-input>
              </div>
              <div class="education_background">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="thoroughList1[index].workKeyPoint"
                >
                </el-input>
              </div>
              <div class="operating_button">
                <div class="save" @click="clickExperiencesSave(index)">保存</div>
                <div class="cancel" @click="clickCancelExperiences(index)">取消</div>
              </div>
            </div>
          </el-form-item>
        </div>

        <div class="thorough2">
          <div
            class="thorough1_item"
            @mouseover="item.isShow = true"
            @mouseleave="item.isShow = false"
            v-for="(item, index) in form.experiences"
            :key="index"
          >
            <div class="top">
              <div class="thorough1_icon"></div>
              <div class="thorough1_time">{{ item.inductionTime }}~{{ item.quitTime }}</div>
              <div class="thorough1_Msg">
                {{ item.companyName }}
              </div>
              <div class="thorough1_operate" v-show="item.isShow">
                <div class="compile" @click="thorough1Compile(item, index)">
                  <i class="el-icon-edit"></i>
                </div>
                <div class="removeTh" @click="thorough1Remove(index)">
                  <i class="el-icon-delete"></i>
                </div>
              </div>
            </div>
            <div class="bottom">
              {{ item.workKeyPoint }}
            </div>
          </div>
        </div>

        <el-form-item style="margin-top: 0px; margin-bottom: 0px">
          <div class="H" style="margin-bottom: 18px">
            <div class="line"></div>
            <div class="title">附件</div>
          </div>
        </el-form-item>

        <el-form-item label="上传附件：">
          <div>
            <uploadFile
              :fileList.sync="form.accessorys"
              @fileAddr="fileAddr"
              @fileLook="fileLook"
              @removeUrl="removeUrl"
            ></uploadFile>
          </div>
        </el-form-item>
      </el-form>

      <!--  -->
      <div class="save_key">
        <div class="save_key_button" @click="accomplish">保存</div>
        <div class="retreat" @click="clickReverseBack">返回上级</div>
      </div>
    </div>
  </div>
</template>
<script>
import uploadFile from '../components/uploadFile'
import { saveKeyPerson, getKeyPersons, updateKeyPerson } from '@/api/businessCenter.js'
import uploadLogo from '../components/uploadLogo.vue'
import CascaderArea from '../components/CascaderArea.vue'

export default {
  components: { uploadLogo, CascaderArea, uploadFile },
  data() {
    return {
      echo: null,
      form: {
        accessory: '',
        accessorys: [],
        age: 0,
        briefIntroduction: '',
        city: '',
        clueCode: '',
        createName: '',
        createTime: '',
        educationals: [],
        email: '',
        enterprise: '',
        experiences: [],
        headPortrait: '',
        name: '',
        nation: '',
        nativePlace: '',
        personCode: '',
        phone: '',
        position: '',
        province: '',
        sex: '',
        updateName: '',
        updateTime: '',
        weChat: ''
      },
      // 正则
      rules: {
        //name: [{ required: true, message: '请输入姓名' }],
        //sex: [{ required: true, message: '请选择性别' }],
        //age: [{ required: true, message: '请输入年龄' }],
        //nativePlace: [{ required: true, message: '请输入籍贯' }],
        //phone: [{ required: true, message: '请输入手机号' }],
        //enterprise: [{ required: true, message: '请输入当前企业' }],
        //position: [{ required: true, message: '请输入当前职位' }],
        //briefIntroduction: [{ required: true, message: '请输入人物简介' }]
      },
      // 学历
      educationList: ['大专', '本科', '硕士', '博士'],
      // 编辑好的教育经历展示的数组数据
      thoroughList: [],
      // 编辑好的工作经历数组数据
      thoroughList1: [],
      accessorys: [],
      row: {},
      rowKey: {}
    }
  },

  computed: {},

  watch: {},

  methods: {
    // 人物头像
    uploadOneImgShow(value) {
      this.form.headPortrait = value
    },
    // 新增 --> 地点
    searchArae(val) {
      this.form.nation = val.country
      this.form.province = val.province
      this.form.city = val.city
    },
    // 添加教育经历
    clickAddDducation() {
      this.thoroughList.push({
        createName: '',
        createTime: '',
        department: '', // 院系
        education: '本科', // 学历
        endDate: '', // 	结束时间
        id: 0,
        major: '', // 就读专业
        personCode: '', // 关键人编号
        qualification: '', // 学位
        schoolName: '', // 学校名称
        startDate: '', // 	开始时间
        updateName: '',
        updateTime: ''
      })
    },
    // 添加工作经历
    clickAddExperiences() {
      this.thoroughList1.push({
        companyName: '', // 公司名称
        createName: '',
        createTime: '',
        id: 0,
        inductionTime: '', // 入职时间
        personCode: '', // 	关键人编号
        quitTime: '', // 离职时间
        updateName: '',
        updateTime: '',
        workKeyPoint: '' // 公司重点
      })
    },
    // 点击保存教育经历
    clickEducationSave(idx) {
      console.log(this.thoroughList);
      this.thoroughList.forEach((item, index) => {
        if (idx == index) {
          let items = item
          this.$set(items, 'isShow', false)
          this.form.educationals.push(items)
          this.thoroughList.splice(idx, 1)
        }
      })
      console.log(this.thoroughList);
    },
    // 取消当前教育经历
    clickCancelEducation(idx) {
      this.thoroughList.forEach((item, index) => {
        if (index == idx) {
          this.thoroughList.splice(idx, 1)
        }
      })
    },
    // 编辑好的教育经历 编辑
    thoroughCompile(it, idx) {
      this.thoroughList.push(it)
      this.form.educationals.forEach((item, index) => {
        if (index == idx) {
          this.form.educationals.splice(index, 1)
        }
      })
    },
    // 编辑好的教育经历 删除
    thoroughRemove(idx) {
      this.form.educationals.forEach((item, index) => {
        if (index == idx) {
          this.form.educationals.splice(idx, 1)
        }
      })
    },

    // 点击保存工作经历
    clickExperiencesSave(idx) {
      this.thoroughList1.forEach((item, index) => {
        if (idx == index) {
          let items = item
          this.$set(items, 'isShow', false)
          this.form.experiences.push(items)
          this.thoroughList1.splice(idx, 1)
        }
      })
    },
    // 取消当前工作经历
    clickCancelExperiences(idx) {
      this.thoroughList1.forEach((item, index) => {
        if (index == idx) {
          this.thoroughList1.splice(idx, 1)
        }
      })
    },

    // 编辑好的工作经历 编辑
    thorough1Compile(it, idx) {
      this.thoroughList1.push(it)
      this.form.experiences.forEach((item, index) => {
        if (index == idx) {
          this.form.experiences.splice(index, 1)
        }
      })
    },
    // 编辑好的工作经历 删除
    thorough1Remove(idx) {
      this.form.experiences.forEach((item, index) => {
        if (index == idx) {
          this.form.experiences.splice(idx, 1)
        }
      })
    },
    // 附件  短路径
    fileAddr(val) {},
    // 附件 长路径
    fileLook(val) {
      this.accessorys.push(val)
    },
    // 移除
    removeUrl(file) {
      this.accessorys.forEach((item, index) => {
        if (item.uid) {
          if (item.uid == file.uid) {
            this.accessorys.splice(index, 1)
          }
        } else {
          if (item == file.url) {
            this.accessorys.splice(index, 1)
          }
        }
      })
    },

    // 点击保存
    accomplish() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // 新增
          if (this.echo == 0) {
            this.form.updateTime = this.initDay
            this.form.educationals.forEach((item, index) => {
              delete this.form.educationals[index].isShow
            })

            this.form.experiences.forEach((item, index) => {
              delete this.form.experiences[index].isShow
            })
            this.form.clueCode = this.row.clueCode
            this.form.accessorys = []
            this.accessorys.forEach((item, index) => {
              if (item.uid) {
                this.form.accessorys.push(item.url)
              } else {
                this.form.accessorys.push(item)
              }
            })
            const { data: res } = await saveKeyPerson(this.form)
            if (res.resultCode == 200) {
              this.$router.push({
                path: '/businessCenter/clueCenter/clueParticulars'
              })
              this.$message.success('新增成功')
            }
          } else if (this.echo == 1) {
            // 编辑
            this.form.accessorys = []
            this.accessorys.forEach((item, index) => {
              if (item.uid) {
                this.form.accessorys.push(item.url)
              } else {
                this.form.accessorys.push(item)
              }
            })
            console.log(this.form);
            const { data: res } = await updateKeyPerson(this.form)
            if (res.resultCode == 200) {
              this.$router.go(-1)
              this.$message.success('编辑成功')
            }
          }
        }
      })
    },
    //获取当前时间并格式化
    initDay() {
      const date = new Date() // 得到当前时间
      const year = date.getFullYear() // 年
      const mont = date.getMonth() + 1 // 月
      const dat = date.getDate() // 日
      const hour = date.getHours() // 时
      const minute = date.getMinutes() // 分
      const second = date.getSeconds() // 秒
      const monts = mont < 10 || mont === 0 ? '0' + mont : mont // 月
      const dats = dat < 10 || dat === 0 ? '0' + dat : dat // 日
      const hours = hour < 10 || hour === 0 ? '0' + hour : hour // 时
      const minutes = minute < 10 ? '0' + minute : minute // 分
      const seconds = second < 10 ? '0' + second : second // 秒
      return `${year}-${monts}-${dats} ${hours}:${minutes}:${seconds}`
    },
    // 点击返回上一级
    clickReverseBack() {
      this.$router.go(-1)
    },
    // 回显数据
    async getEchoData() {
      const { data: res } = await getKeyPersons({
        baseParam: {
          pageNum: 1,
          pageSize: 10
        },
        clueCode: this.rowKey.clueCode,
        order: 'desc',
        personCode: this.rowKey.personCode
      })

      this.form = res.data.list[0]
      this.accessorys = []
      if (res.data.list[0].accessorys != null) {
        res.data.list[0].accessorys.forEach((item, index) => {
          this.accessorys.push(item)
        })
      }
    }
  },

  created() {
    let rowKey = sessionStorage.getItem('rowKey') // 上一级页面的数据
    let row1 = sessionStorage.getItem('row1') // 首页的数据
    if (row1) {
      this.row = JSON.parse(row1)
    } else {
      this.row = JSON.parse(this.$route.query.row)
    }
    let echo = sessionStorage.getItem('echo1')
    this.echo = echo
    if (rowKey) {
      // 编辑回显需要的
      this.rowKey = JSON.parse(rowKey)
    }
    if (echo == 1) {
      this.getEchoData()
    }
  },

  mounted() {}
}
</script>
<style scoped lang="less">
.form {
  background-color: #fff;
  padding-top: 35px;
  .H {
    display: flex;
    height: 30px;
    align-items: center;
    margin-bottom: 51px;
    transform: translateX(-111px);

    .line {
      width: 4px;
      height: 18px;
      border-radius: 2px;
      background-color: #17757a;
      margin-left: 16px;
    }
    .title {
      font-size: 16px;
      font-weight: 500;
      color: #17757a;
      margin-left: 7px;
    }
    .addition {
      display: flex;
      margin-left: 850px;
      align-items: center;
      cursor: pointer;
      /deep/.el-icon-circle-plus-outline {
        font-size: 18px;
        color: #17757a;
        line-height: -1px;
      }
      .addText {
        margin-left: 5px;
        color: #17757a;
        font-size: 16px;
      }
    }
  }
  .table {
    margin-left: 81px;
    border: 1px solid #dcdee0;
    border-radius: 4px;
    width: 1239px;

    .img_name_sex {
      display: flex;
      width: 1239px;
      border-bottom: 1px solid #dcdee0;
    }
    .age_native_phone {
      display: flex;
      width: 1239px;
      border-bottom: 1px solid #dcdee0;
    }
    .email_WeChat_position {
      display: flex;
      width: 1239px;
      border-bottom: 1px solid #dcdee0;
    }
    .enterprise_work_description {
      display: flex;
      width: 1239px;
    }
    .formItemDuty {
      height: 64px;
    }
    /deep/.el-form-item {
      margin-bottom: 0px;
    }
    /deep/.el-form-item__label {
      background-color: #f7f8fa;
      margin: 0px;
      height: 64px;
      line-height: 64px;
    }
    /deep/.el-input__inner {
      border-radius: 0px;
      width: 238px;
      height: 64px;
      border: none;
      // box-sizing: border-box;
    }
    /* /deep/.el-form-item__error {
      z-index: 99;
    }
    /deep/.el-icon-arrow-up:before {
      content: '';
    } */

    .left_right {
      border-left: 1px solid #dcdee0;
      border-right: 1px solid #dcdee0;
    }
    .one {
      box-sizing: border-box;
      width: 240px;
      height: 64px;
    }
    .two {
      // border-left: 0px;
      // border-right: 0px;
      box-sizing: border-box;
      width: 240px;
      height: 64px;
    }
    .three {
      // border-left: 0px;
      box-sizing: border-box;
      border-right: 0px;
      width: 420px;
      height: 64px;
    }
    // 人物头像
    .headPortrait {
      display: flex;
      align-items: center;
      padding-left: 12px;
    }
    // 性别
    .sex {
      padding-left: 15px;
      display: flex;
      align-items: center;

      /deep/.el-radio__inner {
        width: 16px;
        height: 16px;
      }
      /deep/.el-radio__label {
        font-size: 14px;
      }
    }
  }
}
.educationItem {
  border-radius: 2px;
  border: 1px solid #c4c4c4;
  width: 667px;
  // height: 153px;
  background-color: #fafdfb;
  padding: 13px 0 0 12px;
  box-sizing: border-box;
  margin-bottom: 10px;

  .date_school {
    /deep/.el-date-editor {
      width: 150px;
    }
    .schoolName {
      width: 290px;
      margin-left: 11px;
    }
  }
  .education_background {
    margin-top: 15px;
    .input1 {
      width: 150px;
    }
    .input2 {
      width: 232px;
      margin: 0 10px;
    }
  }
  .operating_button {
    display: flex;
    align-items: center;
    height: 63px;
    justify-content: flex-end;
    padding-right: 27px;
    .save {
      width: 64px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      background-color: #17757a;
      color: #fff;
      cursor: pointer;
    }
    .cancel {
      width: 64px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      border: 1px solid #17757a;
      color: #17757a;
      background-color: #fff;
      cursor: pointer;
      margin-left: 22px;
    }
  }
}
.thorough1 {
  padding-left: 100px;

  .thorough1_item {
    display: flex;
    font-size: 14px;
    color: #333333;
    margin-bottom: 10px;
    border: 1px solid #c4c4c4;
    height: 36px;
    align-items: center;

    // .thorough1_icon{}
    .thorough1_time {
      margin: 0 17px 0 10px;
    }
    // .thorough1_Msg{}
    .thorough1_operate {
      display: flex;
      margin-left: 30px;
      .compile {
        width: 16px;
        height: 16px;
        cursor: pointer;
        margin-right: 10px;
        .el-icon-edit {
          color: #c4c4c4;
        }
      }
      .removeTh {
        width: 16px;
        height: 16px;
        cursor: pointer;
        .el-icon-delete {
          color: #c4c4c4;
        }
      }
    }
  }
}
.thorough2 {
  padding-left: 100px;

  .thorough1_item {
    // display: flex;
    font-size: 14px;
    color: #333333;
    margin-bottom: 10px;
    border: 1px solid #c4c4c4;
    height: 50px;
    // align-items: center;

    .top {
      display: flex;
      align-items: center;
    }
    .bottom {
      margin-top: 11px;
      padding-left: 27px;
      color: #999999;
    }

    // .thorough1_icon{}
    .thorough1_time {
      margin: 0 17px 0 10px;
    }
    // .thorough1_Msg{}
    .thorough1_operate {
      display: flex;
      margin-left: 30px;
      .compile {
        width: 16px;
        height: 16px;
        cursor: pointer;
        margin-right: 10px;
        .el-icon-edit {
          color: #c4c4c4;
        }
      }
      .removeTh {
        width: 16px;
        height: 16px;
        cursor: pointer;
        .el-icon-delete {
          color: #c4c4c4;
        }
      }
    }
  }
}
// 工作经历
.experiencesItem {
  border-radius: 2px;
  border: 1px solid #c4c4c4;
  width: 667px;
  // height: 153px;
  background-color: #fafdfb;
  padding: 13px 0 0 12px;
  box-sizing: border-box;
  margin-bottom: 10px;

  .date_school {
    /deep/.el-date-editor {
      width: 150px;
    }
    .schoolName {
      width: 290px;
      margin-left: 11px;
    }
  }
  .education_background {
    width: 622px;
    margin-top: 15px;
    .input1 {
      width: 150px;
    }
    .input2 {
      width: 232px;
      margin: 0 10px;
    }
  }
  .operating_button {
    display: flex;
    align-items: center;
    height: 63px;
    justify-content: flex-end;
    padding-right: 27px;
    .save {
      width: 64px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      background-color: #17757a;
      color: #fff;
      cursor: pointer;
    }
    .cancel {
      width: 64px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      border: 1px solid #17757a;
      color: #17757a;
      background-color: #fff;
      cursor: pointer;
      margin-left: 22px;
    }
  }
}

.save_key {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  .save_key_button {
    width: 126px;
    height: 32px;
    background-color: #17757a;
    border-radius: 4px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
  }
  .retreat {
    width: 126px;
    height: 32px;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #17757a;
    color: #17757a;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 21px;
    cursor: pointer;
    font-size: 14px;
  }
}
</style>
